import { Component } from '@angular/core';
import { BarristerSolicitorFormatDrawerViewModel } from './barrister-solicitor-format-drawer.view-model';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiModule } from 'src/app/ui/ui.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'barrister-solicitor-format-drawer',
	templateUrl: './barrister-solicitor-format-drawer.component.html',
	providers: [BarristerSolicitorFormatDrawerViewModel],
	imports: [
		AtomicModule,
		CommonModule,
		FormsModule,
		UiModule,
		TablerIconsModule,
		MatTooltipModule,
	],
	styles: [
		`
			::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface {
				word-break: normal !important;
				white-space: pre-line !important;
				text-align: left !important;
				word-wrap: break-word !important;
				display: block !important;
				box-sizing: border-box !important;
				max-width: 400px !important;
				width: 100% !important;
			}
		`,
	],
})
export class BarristerSolicitorFormatDrawerComponent {
	constructor(public vm: BarristerSolicitorFormatDrawerViewModel) {}
}
